module.exports = __webpack_public_path__ + "static/img/sciserver_logo_icon_blue.e304c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sciserver_logo_icon_blue.png
// module id = WCQg
// module chunks = 1